import React from "react";
import "./GameCardStyle.scss";
import { motion } from "framer-motion";

const cardVariants = {
  initial: { scale: 1, rotate: 0, boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" },
  hover: { scale: 1.05, rotate: -5, boxShadow: "0px 0px 2rem rgba(132, 0, 255, 0.75)", transition: { type: "spring", stiffness: 300 } },
  tap: { scale: 0.95, rotate: -2.5 },
};

function GameCard({ className, gameImageSrc, gameNameText, gameId, onClick }) {
  return (
    <motion.div
      gameId={gameId}
      onClick={onClick}
      className={`game-card ${className}`}
      variants={cardVariants}
      initial="initial"
      whileHover="hover"
      whileTap="tap"
    >
      <div className="img-box">
        <img src={gameImageSrc} alt="Image" className="game-image"/>

      </div>
      <div className="game-card-body">
        <h3 className="game-name">{gameNameText}</h3>
      </div>
    </motion.div>
  );
}

export default GameCard;
